export const WEB_VIEW_ACTIONS = {
  LOGOUT: "LOGOUT",
  SET_TOKEN: "SET_TOKEN",
  SET_LANGUAGE: "SET_LANGUAGE",
  REQUEST_TOKEN: "REQUEST_TOKEN",
  GO_TO_EXTERNAL_URL: "GO_TO_EXTERNAL_URL",
  GO_TO_LOGIN: "GO_TO_LOGIN",
  DOWNLOAD_FILE: "DOWNLOAD_FILE",
  SET_IS_BIOMETRIC_ENABLED: "SET_IS_BIOMETRIC_ENABLED",
  ON_CHANGE_BIOMETRIC: "ON_CHANGE_BIOMETRIC",
  SHARE: "SHARE",
  PRESENT_INTERCOM_MESSENGER: "PRESENT_INTERCOM_MESSENGER",
} as const;

export const IS_WEB_VIEW = window.ReactNativeWebView !== undefined;
